import React, { useState, useEffect, useRef } from 'react';
import WkModal from 'components/Modal';
import './DakaRewardModal.scss';

// 按需加载，只加载当前天对应的图片，避免内存浪费（执行 npm run convert-daka 后可用 webp）
const DAKA_LOADERS = {
    1: () => import('asset/daka/daka1.jpg'),
    2: () => import('asset/daka/daka2.jpg'),
    3: () => import('asset/daka/daka3.jpg'),
    4: () => import('asset/daka/daka4.jpg'),
    5: () => import('asset/daka/daka5.jpg'),
    6: () => import('asset/daka/daka6.jpg'),
    7: () => import('asset/daka/daka7.jpg'),
};

const DakaRewardModal = React.memo(({ visible, day, onClose }) => {
    const [imgSrc, setImgSrc] = useState(null);
    const loadedDayRef = useRef(null);

    useEffect(() => {
        if (!visible || day < 1 || day > 7) {
            setImgSrc(null);
            loadedDayRef.current = null;
            return;
        }
        const loader = DAKA_LOADERS[day];
        if (!loader) return;

        loadedDayRef.current = day;
        loader()
            .then((m) => {
                if (loadedDayRef.current === day) {
                    setImgSrc(m.default);
                }
            })
            .catch(() => {
                setImgSrc(null);
            });

        return () => {
            loadedDayRef.current = null;
            setImgSrc(null);
        };
    }, [visible, day]);

    return (
        <WkModal
            visible={visible}
            onOk={onClose}
            onCancel={onClose}
            okText="太棒啦"
            cancelVisble={false}
            title={`第${day}天打卡成功 🎉`}
            tongquStyle
            cls="daka-reward-modal"
            content={
                <div className="daka-reward-content">
                    {imgSrc && (
                        <img
                            src={imgSrc}
                            alt={`第${day}天打卡`}
                            loading="lazy"
                            decoding="async"
                            className="daka-reward-img"
                        />
                    )}
                    {!imgSrc && <div className="daka-reward-placeholder">加载中...</div>}
                </div>
            }
        />
    );
});

export default DakaRewardModal;
